import { VStack } from '@chakra-ui/react';

import { TaskComment, TaskCommentWithReplies } from '../../../models';
import { useCreateTaskCommentMutation } from '../../../services';
import { CenteredSpinner } from '../../../components';
import { NewCommentInput, TaskThread } from '.';

export const TaskThreads = ({
  threads = [],
  taskId,
}: {
  threads?: TaskComment[];
  taskId: number;
}) => {
  const [createTaskComment, { isLoading }] = useCreateTaskCommentMutation();

  const commentsWithReplies = [...threads]
    .sort(function (a, b) {
      return Number(b.parent === null) - Number(a.parent === null);
    })
    .reduce((acc, item) => {
      if (item.parent === null) {
        acc.push({ ...item, replies: [] });
      } else {
        const comment = acc.find(({ id }) => item.parent?.id === id);
        comment?.replies?.push(item);
      }

      return acc;
    }, [] as TaskCommentWithReplies[]);

  const handleAddNewComment = ({
    comment,
    parentId,
  }: {
    comment: string;
    parentId?: number;
  }) => {
    createTaskComment({ comment, parentId, taskId });
  };

  return (
    <VStack align="stretch" justify="space-between" h="full">
      {isLoading && <CenteredSpinner />}

      <VStack align="stretch" gap="6">
        {commentsWithReplies.map(comment => (
          <TaskThread
            taskComment={comment}
            key={comment.id}
            isDisabled={isLoading}
            onAddNewReply={(reply, parentId) =>
              handleAddNewComment({
                comment: reply,
                parentId,
              })
            }
          />
        ))}
      </VStack>

      <NewCommentInput
        isDisabled={isLoading}
        onSubmit={comment => handleAddNewComment({ comment })}
      />
    </VStack>
  );
};
